import axios from "axios";

export const deleteClub = async (id, token) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL_USER}/clubs/deleteClub/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response?.data?.message;
    }
    if (error.request) {
    }
    // throw new Error(error.message);
    return error.message;
  }
};
